import gql from 'graphql-tag';

export const editorBlockContentFragment = gql`
  fragment editorBlockContentFragment on EditorContent {
    id
    sections {
      id
      rows {
        id
        type
        columnCount
        cells {
          id
          width
          type
          nodes {
            id
            type
            content
            srcUrl
            imageId
            linkUrl
            fields {
              id
              type
              category
              mergeKey
              recipientId
              userId
              customName
              value
              inputSettings {
                type
                required
                label
                richTextLabel
                defaultValue
                helpText
                connectedId
                width
              }
            }
            inputFieldSets {
              ids
            }
            caption
            heading
            imageSize
            imageAlign
            imageTransforms {
              translateX
              translateY
              scale
            }
            dividerType
            dividerPadding
            tableStyle {
              borderColor
              headerRowBackgroundColor
              alternateRowColor
            }
            name
            preCalculated
            locked
            pricingTableSections {
              id
              displayName
              columns {
                id
                name
                displayName
                width
                enabled
              }
              rows {
                id
                values {
                  columnId
                  value
                }
                discountFlatFee
                taxFlatFee
              }
              sectionSummary {
                discount {
                  value
                  enabled
                  flatFee
                  displayName
                }
                tax {
                  value
                  enabled
                  flatFee
                  displayName
                }
                price {
                  value
                  enabled
                  flatFee
                  displayName
                }
              }
            }
            pricingTableSummaryValues {
              displayName
              discount {
                value
                enabled
                flatFee
                displayName
              }
              tax {
                value
                enabled
                flatFee
                displayName
              }
              price {
                value
                enabled
                flatFee
                displayName
              }
            }
            currencySettings {
              formatOptions {
                currency
                currencyDisplay
              }
              locale
            }
          }
        }
      }
    }
  }
`;
